import React from "react";
import unsplash from "../api/unsplash";
import ImageList from "./ImageList";
import SearchBar from "./SearchBar";
import ReactTypingEffect from "react-typing-effect";

class ImageSearch extends React.Component {
  state = { images: [] };
  onSearchSubmit = async (term) => {
    console.log(term);
    const response = await unsplash.get("/search/photos", {
      params: { query: term },
    });
    //   .then((res) => {
    //     console.log(res.data.results);
    //   })
    //   .catch((e) => {
    //     console.log(e.message);
    //   });
    this.setState({ images: response.data.results });
  };
  componentDidMount() {
    document.body.style.backgroundColor = "lightblue";
  }

  render() {
    console.log("if you see this, hire me, you already got this far :(");
    return (
      <div className="container ui container">
        <h3 className="image__search__title">
          <ReactTypingEffect text={["Image Search App", "Search an image!"]} />
        </h3>
        <SearchBar onSubmit={this.onSearchSubmit} />
        Found: {this.state.images.length} images
        <div>
          <ImageList images={this.state.images} />
        </div>
      </div>
    );
  }
}
export default ImageSearch;
